if (!customElements.get("sticky-product-add-to-cart")) {
  class StickyProductAddToCart extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector("button");
      this.originalButton = document.getElementById(this.dataset.targetId);
      this.mobileQuery = window.matchMedia("(max-width: 749px)");
      this.originalIsVisible = false;

      if (!this.button || !this.originalButton) {
        this.remove();
        return;
      }

      this.handleStickyClick = () => {
        if (this.button.disabled || this.button.getAttribute("aria-disabled") === "true") return;
        this.originalButton.click();
      };

      this.updateVisibility = () => {
        const shouldShow = this.mobileQuery.matches && !this.originalIsVisible;
        this.classList.toggle("is-visible", shouldShow);
        this.setAttribute("aria-hidden", shouldShow ? "false" : "true");
        this.button.tabIndex = shouldShow ? 0 : -1;
      };

      this.syncButton = () => {
        const disabled = this.originalButton.disabled || this.originalButton.getAttribute("aria-disabled") === "true";
        this.button.innerHTML = this.originalButton.innerHTML;
        this.button.disabled = disabled;
        this.button.setAttribute("aria-disabled", disabled ? "true" : "false");
        this.button.classList.toggle("loading", this.originalButton.classList.contains("loading"));
      };

      this.intersectionObserver = new IntersectionObserver(([entry]) => {
        this.originalIsVisible = entry.isIntersecting;
        this.updateVisibility();
      }, { threshold: 0.01 });

      this.mutationObserver = new MutationObserver(this.syncButton);
      this.intersectionObserver.observe(this.originalButton);
      this.mutationObserver.observe(this.originalButton, {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true
      });

      this.button.addEventListener("click", this.handleStickyClick);
      this.mobileQuery.addEventListener("change", this.updateVisibility);
      this.syncButton();
      this.updateVisibility();
    }

    disconnectedCallback() {
      this.intersectionObserver?.disconnect();
      this.mutationObserver?.disconnect();
      this.button?.removeEventListener("click", this.handleStickyClick);
      this.mobileQuery?.removeEventListener("change", this.updateVisibility);
    }
  }

  customElements.define("sticky-product-add-to-cart", StickyProductAddToCart);
}
